module.exports = __webpack_public_path__ + "img/v3-fileDOI.ddd74235.png";